import React from "react";
import PolicyPage from "./PolicyPage";
import { STORE } from "../config/store";

const sections = [
  {
    title: "Records covered by a request",
    paragraphs: [`Records within scope are personal details that ${STORE.brand} controls for ordering or support. They can include delivery entries, payment-session identifiers, messages about an order and evidence attached to a product case. A shopper manages the basket copy held solely by their browser.`],
  },
  {
    title: "How to submit a request",
    items: [
      "Where practical, write from the email associated with the transaction or correspondence.",
      "State whether access or correction is requested and describe the data precisely.",
      "Include an order reference or correspondence date that helps locate the record.",
      "A correction request should pair each disputed entry with its proposed accurate value.",
      "Exclude every card credential from the request.",
    ],
  },
  {
    title: "Identity and third-party data",
    paragraphs: ["Before releasing or changing a record, proportionate information may be requested to verify the requester and protect another person's data. A request made for someone else must show the authority to act. Any information belonging to another individual is separated or withheld where disclosure is not permitted."],
  },
  {
    title: "Response period",
    paragraphs: [`For a qualifying ${STORE.operatingRegion} access or correction request, the statutory clock is 40 calendar days from receipt. Within that window the store must comply, or send the notice and explanation prescribed for an inability to complete the request. Material already available is supplied within the window, and the balance follows as soon as practicable. Where refusal is lawfully permitted, the response gives the required reason.`],
  },
  {
    title: "Erasure, consent and retention concerns",
    paragraphs: ["A customer may ask for data that has outlived its transaction, accounts, security, dispute or compulsory-record purpose to be erased, and may withdraw consent for a new unrelated use. The response will identify data that can be removed and any record that must still be kept for an applicable purpose. Withdrawing consent does not undo processing already lawfully completed."],
  },
  {
    title: "Challenge and further rights",
    paragraphs: ["If the requester believes the outcome is incomplete, they should identify the missing record or disputed correction for a second review. These steps do not restrict a complaint to the privacy authority available to the individual or a stronger data right that applies to the processing."],
  },
];

export default function DataRights() {
  return <PolicyPage title="Consumer Data Rights" intro="The request path for access, correction, erasure concerns and consent questions about customer records." sections={sections} related={[["Privacy Policy", "/privacy"], ["Cookie & Storage Notice", "/cookies"], ["Complaints & Policy Updates", "/complaints"]]} />;
}
